import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RestrictedLayoutComponent } from './components/layout/layout.component';
import { NotFound404Component } from './components/not-found404/not-found404.component';
import { AuthGuard } from '@http/guards/auth.guard';
import { AuthComponent } from './components/auth/auth.component';
import { TemporaryDowntimeComponent } from './components/temporary-downtime/temporary-downtime.component';

const router: Routes = [
    {
      path: '', component: RestrictedLayoutComponent,
      children: [
        // {
        //   path: '',
        //   canActivate: [AuthGuard],
        //   loadChildren: () => import('./modules/dashboard/dashboard.module').then(file => file.DashboardModule)
        // },
        {
          path: '',
          canActivate: [AuthGuard],
          loadChildren: () => import('./modules/reward/reward.module').then(file => file.RewardModule)
        },
        // {
        //   path: 'earn',
        //   canActivate: [AuthGuard],
        //   loadChildren: () => import('./modules/earn/earn.module').then(file => file.EarnModule),
        // },
        // {
        //   path: 'transactions',
        //   canActivate: [AuthGuard],
        //   loadChildren: () => import('./modules/transactions/transactions.module').then(file => file.TransactionsModule)
        // },
        // {
        //   path: 'live-transactions',
        //   canActivate: [AuthGuard],
        //   loadChildren: () => import('./modules/live-transactions/live-transactions.module').then(file => file.LiveTransactionsModule)
        // },
        {
          path: 'profile',
          canActivate: [AuthGuard],
          loadChildren: () => import('./modules/profile/profile.module').then(file => file.ProfileModule)
        }
      ]
    },
    {
      component: TemporaryDowntimeComponent,
      path: 'downtime'
    },
    {
      path: 'auth',
      component: AuthComponent
    },
    {
      path: '**',
      component: NotFound404Component
    }
  ];

@NgModule({
  imports: [RouterModule.forRoot(router, {
    onSameUrlNavigation: 'reload',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }